import { CountryCode } from "libphonenumber-js";
import { Address } from "../../../shared/address/Address";
import { DataTableColumn } from "../../../shared/components/data-table/DataTableColumn.model";
import { formatPhoneNumber } from "../../../utilities/PhoneUtility";
import { getYesNoFromBoolean } from "../../../utilities/StringUtility";
import { OrganizationLegacyMember } from "./member/OrganizationMember";
import { PartnerOrganization } from "./PartnerOrganization";

export interface Organization {
    id: string;
    organization_id: number;
    access_key: string;
    name: string;
    organization_name: string;
    org_name_to_guest: string;
    contact_first_name: string;
    contact_last_name: string;
    website: string;
    logo_id: number;
    logo_url: string;
    policy_billing_method_id: number;
    verification_billing_method_id: number;
    billing_contact_name: string;
    billing_contact_phone_number: string;
    billing_contact_email_address: string;
    claim_contact_name?: string;
    claim_contact_phone_number?: string;
    claim_contact_email_address?: string;
    invoice_date: number;
    status_id: number;
    source_id: number;
    start_get_reservation_from: string;
    created_date: string;
    notification_email: string;
    auto_charge_invoice: string;
    address: Address;
    phone: any,
    email: any,
    members: OrganizationLegacyMember[];
    sync_all_properties: number;
    is_receiving_alert: string;
    for_guest_verification: number;
    for_reservation: number;
    send_check_to_safely: number;
    email_guest_for_details: number;
    notify_guest_verification: number;
}
export interface OrganizationsTable {
    organizations: Organization[];
    totalRecords: number;
}

export interface OrganizationRow {
    id: string;
    name: string;
    contactName: string;
    phoneNumber: string;
    email: string;
    // sendCheckToSafely: string;
    emailGuestForAdditionalInfo: string;
    statusId: number;
    pillStatus: string;
}

export const OrganizationColumns: DataTableColumn[] = [
    { column: 'id', display: 'Safely Org. ID' },
    { column: 'name', display: 'Organization Name' },
    { column: 'contactName', display: 'Contact Name' },
    { column: 'email', display: 'Email' },
    { column: 'phoneNumber', display: 'Phone' },
    // { column: 'sendCheckToSafely', display: 'ACH Payments' },
    { column: 'emailGuestForAdditionalInfo', display: 'Verification Emails' },
    { column: 'pillStatus', display: 'Status' }
]

export const getOrganizationRowFromOrganization = (organization: any): OrganizationRow => {
    return {
        id: organization.organizationId,
        name: organization.legalName,
        contactName: `${organization.contactFirstName} ${organization.contactLastName}`,
        email: organization.contactEmail,
        phoneNumber: organization.contactPhoneNumber,
        // sendCheckToSafely: getYesNoFromBoolean(organization.sendCheckToSafely),
        emailGuestForAdditionalInfo: getYesNoFromBoolean(organization.notifyGuestForAdditionalInfo),
        statusId: organization.status,
        pillStatus: organization.status
    }
}

export const getPendingOrganizationRowFromOrganization = (organization: any, countryCode: CountryCode): any => {
    return {
        id: organization.organization_id,
        name: organization.organization_name,
        contactName: `${organization.contact_first_name} ${organization.contact_last_name}`,
        email: organization.email_address,
        phoneNumber: formatPhoneNumber(organization.phone_number, countryCode),
        // sendCheckToSafely: getYesNoFromBoolean(organization.sendCheckToSafely),
        emailGuestForAdditionalInfo: getYesNoFromBoolean(organization.for_guest_verification),
        statusId: organization.status_id,
        pillStatus: organization.status
    }
}